import { render, staticRenderFns } from "./SpinnerElement.vue?vue&type=template&id=6c49edbc&scoped=true&"
import script from "./SpinnerElement.vue?vue&type=script&lang=js&"
export * from "./SpinnerElement.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerElement.vue?vue&type=style&index=0&id=6c49edbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c49edbc",
  null
  
)

export default component.exports